import React from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import { Range, getTrackBackground } from 'react-range';

const ThresholdControl = ({
  areaInRange,
  areaThresholdRangeMax,
  areaThresholdRangeMin,
  clampedAreaThreshold,
  features,
  setAreaThreshold,
  setFeatures,
}) => (
  <div className="uploadfield__threshold__details">
    <Range
      values={clampedAreaThreshold}
      step={1}
      min={areaThresholdRangeMin}
      max={areaThresholdRangeMax}
      onChange={threshold => {
        setFeatures(
          features.map(feature =>
            feature.set(
              'checked',
              feature.get('checked') && areaInRange(feature.get('area'))
            )
          )
        );
        setAreaThreshold(threshold);
      }}
      renderTrack={({ props: trackProps, children }) => (
        <div
          onMouseDown={trackProps.onMouseDown}
          onTouchStart={trackProps.onTouchStart}
          className="uploadfield__threshold__track-container"
        >
          <div
            ref={trackProps.ref}
            className="uploadfield__threshold__track"
            style={{
              background: getTrackBackground({
                values: clampedAreaThreshold,
                colors: ['#f6f6f6', '#006a35' /* $primary */, '#f6f6f6'],
                min: areaThresholdRangeMin,
                max: areaThresholdRangeMax,
              }),
            }}
          >
            {children}
          </div>
        </div>
      )}
      renderThumb={({ props: thumbProps, isDragged }) => (
        <div {...thumbProps} className="uploadfield__threshold__thumb">
          <div
            className={cn('uploadfield__threshold__thumb__inner', {
              'is-dragged': isDragged,
            })}
          />
        </div>
      )}
    />
  </div>
);
ThresholdControl.propTypes = {
  areaInRange: PropTypes.func.isRequired,
  areaThresholdRangeMax: PropTypes.number.isRequired,
  areaThresholdRangeMin: PropTypes.number.isRequired,
  clampedAreaThreshold: PropTypes.arrayOf(PropTypes.number.isRequired)
    .isRequired,
  features: PropTypes.object.isRequired,
  setAreaThreshold: PropTypes.func.isRequired,
  setFeatures: PropTypes.func.isRequired,
};

export default ThresholdControl;



// WEBPACK FOOTER //
// ./src/pages/Field/Upload/ThresholdControl.js